export default __webpack_public_path__ + "ecbe95f309be4cee7aa3f894386282f6.ttf";